var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import { Box, Button, Chip, FormControl, InputLabel, MenuItem, OutlinedInput, Select, useTheme, } from '@mui/material';
import { SnackbarSeverity } from 'common/enums/components/snackbar-severity.enum';
import { UPDATE_TOURNAMENT } from 'common/graphql/mutations/tournament/update-tournament';
import { SPORTS } from 'common/graphql/queries/sports/sports';
import { TOURNAMENT } from 'common/graphql/queries/tournament/tournament';
import useDynamicMutation from 'common/hooks/useDynamicMutation';
import CircularProgressMui from 'components/Loading/CircularProgresMui';
import PageSimple from 'components/PageLayouts/simple/PageSimple';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { openSnackbar } from 'store/actions';
var ITEM_HEIGHT = 48;
var ITEM_PADDING_TOP = 8;
var MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250
        }
    }
};
function getStyles(name, personName, theme) {
    return {
        fontWeight: personName.indexOf(name) === -1 ? theme.typography.fontWeightRegular : theme.typography.fontWeightMedium
    };
}
var TournamentSportsSettingsPage = function (_a) {
    var tournamentId = _a.tournamentId;
    var t = useTranslation().t;
    var theme = useTheme();
    var _b = useState(false), isEditMode = _b[0], setIsEditMode = _b[1];
    var _c = useQuery(TOURNAMENT, {
        variables: {
            id: tournamentId,
            showSports: true
        }
    }), data = _c.data, loading = _c.loading;
    useEffect(function () {
        if (data) {
            getSports();
        }
    }, [data]);
    var _d = useLazyQuery(SPORTS), getSports = _d[0], _e = _d[1], sportsData = _e.data, sportsLoading = _e.loading;
    var _f = useState([]), sports = _f[0], setSports = _f[1];
    var _g = useState([]), sportNames = _g[0], setSportNames = _g[1];
    var _h = useState([]), sportObjects = _h[0], setSportObjects = _h[1];
    useEffect(function () {
        var _a, _b, _c, _d, _e;
        if (((_a = data === null || data === void 0 ? void 0 : data.tournament) === null || _a === void 0 ? void 0 : _a.sports) && ((_c = (_b = data === null || data === void 0 ? void 0 : data.tournament) === null || _b === void 0 ? void 0 : _b.sports) === null || _c === void 0 ? void 0 : _c.length) > 0) {
            setSportNames((_e = (_d = data === null || data === void 0 ? void 0 : data.tournament) === null || _d === void 0 ? void 0 : _d.sports) === null || _e === void 0 ? void 0 : _e.map(function (sport) { return sport.displayName; }));
        }
    }, [data]);
    useEffect(function () {
        var _a;
        if ((sportsData === null || sportsData === void 0 ? void 0 : sportsData.sports) && ((_a = sportsData === null || sportsData === void 0 ? void 0 : sportsData.sports) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            setSports(sportsData.sports
                .filter(function (sport) { return sport.id !== '64908c46-8569-4d00-af0f-225106161bb9'; })
                .map(function (sport) { return sport.displayName; }));
            setSportObjects(sportsData.sports.filter(function (sport) { return sport.id !== '64908c46-8569-4d00-af0f-225106161bb9'; }));
        }
    }, [sportsData]);
    var updateTournament = function (data) {
        return useMutation(UPDATE_TOURNAMENT, {
            variables: {
                updateTournamentData: __assign({ id: tournamentId }, data)
            },
            awaitRefetchQueries: true,
            refetchQueries: [
                {
                    query: TOURNAMENT,
                    variables: {
                        id: tournamentId,
                        showSports: true
                    }
                },
            ]
        });
    };
    var dispatch = useDispatch();
    var onSuccess = function () {
        dispatch(openSnackbar({
            message: 'Событие обновлено.',
            severity: SnackbarSeverity.SUCCESS
        }));
    };
    var onError = function (_a) {
        var _b, _c;
        var code = _a.code, errorDetails = _a.errorDetails;
        dispatch(openSnackbar({
            message: errorDetails || code,
            severity: SnackbarSeverity.ERROR
        }));
        setSportNames(((_c = (_b = data === null || data === void 0 ? void 0 : data.tournament) === null || _b === void 0 ? void 0 : _b.sports) === null || _c === void 0 ? void 0 : _c.map(function (sport) { return sport.displayName; })) || []);
    };
    var handleExecuteMutation = useDynamicMutation(updateTournament, onSuccess, onError).handleExecuteMutation;
    var handleSubmit = function (e) {
        var _a;
        e.preventDefault();
        var sportIds = [];
        for (var _i = 0, sportNames_1 = sportNames; _i < sportNames_1.length; _i++) {
            var s = sportNames_1[_i];
            var id = (_a = _.find(sportObjects, { displayName: s })) === null || _a === void 0 ? void 0 : _a.id;
            id && sportIds.push(id);
        }
        var updateObj = {
            sportIds: sportIds
        };
        // console.log(updateObj);
        handleExecuteMutation(__assign({}, updateObj));
        setIsEditMode(false);
    };
    var handleChange = function (event) {
        var value = event.target.value;
        setSportNames(typeof value === 'string' ? value.split(',') : value);
    };
    if (loading || sportsLoading)
        return _jsx(CircularProgressMui, {}, void 0);
    return (_jsx(PageSimple, { header: _jsx("div", __assign({ className: "h-full tw-page-container-shadow flex justify-between items-center" }, { children: _jsx("div", __assign({ className: "tw-page-container-header-title" }, { children: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430 \u0432\u0438\u0434\u043E\u0432 \u0441\u043F\u043E\u0440\u0442\u0430" }), void 0) }), void 0), content: _jsx("div", __assign({ className: "flex tw-page-container-shadow flex-col space-y-40 w-full" }, { children: (sports === null || sports === void 0 ? void 0 : sports.length) > 0 && (_jsxs("form", __assign({ onSubmit: handleSubmit, className: "flex flex-col max-w-320" }, { children: [_jsx("div", __assign({ className: "max-w-288" }, { children: isEditMode ? (_jsxs("div", __assign({ className: "flex flex-row space-x-10" }, { children: [_jsx(Button, __assign({ type: "reset", color: "secondary", onClick: function () { return setIsEditMode(false); } }, { children: t('Отмена') }), void 0), _jsx(Button, __assign({ type: "submit" }, { children: t('Сохранить') }), void 0)] }), void 0)) : (_jsx(Button, __assign({ type: "button", onClick: function () { return setIsEditMode(!isEditMode); } }, { children: t('Редактировать') }), void 0)) }), void 0), _jsx("div", __assign({ className: "pt-20 min-w-288" }, { children: _jsxs(FormControl, __assign({ className: "w-full" }, { children: [_jsx(InputLabel, { children: "\u0412\u0438\u0434\u044B \u0441\u043F\u043E\u0440\u0442\u0430" }, void 0), _jsx(Select, __assign({ disabled: !isEditMode, label: "\u0412\u0438\u0434\u044B \u0441\u043F\u043E\u0440\u0442\u0430", multiple: true, value: sportNames, onChange: handleChange, input: _jsx(OutlinedInput, { className: "\n\t\t\t\t\t\t\tbg-bg-container-inner-lt \n\t\t\t\t\t\t\tdark:bg-bg-container-inner-dk  \n\t\t\t\t\t\t\tdark:text-white", label: "\u0412\u0438\u0434\u044B \u0441\u043F\u043E\u0440\u0442\u0430" }, void 0), renderValue: function (selected) { return (_jsx(Box, __assign({ sx: { display: 'flex', flexWrap: 'wrap', gap: 0.5 } }, { children: selected.map(function (value) { return (_jsx(Chip, { label: value }, value)); }) }), void 0)); }, MenuProps: MenuProps }, { children: sports.map(function (sport) { return (_jsx(MenuItem, __assign({ value: sport, style: getStyles(sport, sportNames, theme) }, { children: sport }), sport)); }) }), void 0)] }), void 0) }), void 0)] }), void 0)) }), void 0), innerScroll: false }, void 0));
};
export default TournamentSportsSettingsPage;
